import { render, staticRenderFns } from "./fid_departure_monitor.vue?vue&type=template&id=72351b74&"
import script from "./fid_departure_monitor.vue?vue&type=script&lang=js&"
export * from "./fid_departure_monitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports